module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r5n9r3r-1742ccb4abc5149173e3c95ce044df5f.svg";